function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import SchemaField from "./SchemaField";
import SchemaLayout from "./SchemaLayout";
import SchemaFieldset from "./SchemaFieldset";
import ArrayField from "./ArrayField";
import BooleanField from "./BooleanField";
import DescriptionField from "./DescriptionField";
import MultiSchemaField from "./MultiSchemaField";
import NumberField from "./NumberField";
import ObjectField from "./ObjectField";
import StringField from "./StringField";
import TitleField from "./TitleField";
import UnsupportedField from "./UnsupportedField";
/*
import {
    MediaObject,
    MediaPreviewObject,
    ImageCropdataObject,
    ImageFocalpointObject,
    ImageFiltersObject,
    ImageAdjustObject
} from "../../Media"

import { AnnotateImageObject } from "../../AnnotateImage"
*/

import registry from "../../registry";
export default _extends({
  AnyOfField: MultiSchemaField,
  ArrayField,
  BooleanField,
  DescriptionField,
  NumberField,
  ObjectField,
  OneOfField: MultiSchemaField,
  SchemaField,
  StringField,
  TitleField,
  UnsupportedField,
  SchemaLayout,
  SchemaFieldset,
  "object": ObjectField
}, registry.fields);